module.exports = new __parcel__URL__("figurative.d25a3795.webp").toString();